import React, { useEffect, useRef } from 'react';

export function usePrevious(
	value: string | number | boolean | null | undefined
): string | number | boolean | null | undefined {
	const ref: React.MutableRefObject<string | number | boolean | null | undefined> = useRef();
	useEffect(() => {
		ref.current = value;
	}, [value]);
	return ref.current;
}

export function toISO8601(date: string | Date): string {
	const z = (n: number): string => (n < 10 ? `0${n}` : `${n}`);
	const offset = (n: number): string => (n < 0 ? `-${z(n * -1)}` : `+${z(n)}`);
	const c = new Date(date);
	return `${c.getUTCFullYear()}-${z(c.getUTCMonth() + 1)}-${z(c.getUTCDate())}T${z(
		c.getUTCHours()
	)}:${z(c.getUTCMinutes())}:${z(c.getUTCSeconds())}${offset(c.getTimezoneOffset() / 60)}:00`;
}

export function timeAgo(timestamp: number): string {
	const now = new Date().getTime();
	const createdDate = new Date(timestamp * 1000); // assuming the timestamp is in seconds
	const seconds = Math.floor((now - createdDate.getTime()) / 1000);

	let interval = seconds / 31536000; // years

	if (interval > 1) {
		const outInterval = Math.floor(interval);

		return outInterval === 1 ? '1 year ago' : `${outInterval} years ago`;
	}

	interval = seconds / 2592000; // months
	if (interval > 1) {
		const outInterval = Math.floor(interval);

		return outInterval === 1 ? '1 month ago' : `${outInterval} months ago`;
	}

	interval = seconds / 86400; // days
	if (interval > 1) {
		const outInterval = Math.floor(interval);

		return outInterval === 1 ? '1 day ago' : `${outInterval} days ago`;
	}

	interval = seconds / 3600; // hours
	if (interval > 1) {
		const outInterval = Math.floor(interval);

		return outInterval === 1 ? '1 hour ago' : `${outInterval} hours ago`;
	}

	interval = seconds / 60; // minutes
	if (interval > 1) {
		const outInterval = Math.floor(interval);

		return outInterval === 1 ? '1 minute ago' : `${outInterval} minutes ago`;
	}
	return 'Just now';
}
